import * as React from 'react';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import SwiperCore, { Autoplay } from 'swiper';
import { className } from '@empori/util';
var FileExtensions = {
    PDF: '.pdf',
    MP4: '.mp4',
    OGG: '.ogg',
    SVG: '.svg'
};
var Direction;
(function (Direction) {
    Direction[Direction["left"] = 0] = "left";
    Direction[Direction["right"] = 1] = "right";
})(Direction || (Direction = {}));
function setLogotypeImageUrl(url) {
    if (url.includes(FileExtensions.SVG)) {
        return url;
    }
    return "".concat(url, "?width=300&format=webp");
}
export function LogotypeSlideshow(_a) {
    var items = _a.items;
    SwiperCore.use([Autoplay]);
    if (!items) {
        return null;
    }
    var breakpoints = {
        0: {
            slidesPerView: 2,
            spaceBetween: 20
        },
        380: {
            slidesPerView: 3,
            spaceBetween: 20
        },
        540: {
            slidesPerView: 4,
            spaceBetween: 30
        },
        800: {
            slidesPerView: 5,
            spaceBetween: 40
        },
        1000: {
            spaceBetween: 50
        }
    };
    return (React.createElement(Swiper, { slidesPerView: 6, autoplay: { delay: 3000 }, loop: items.length > 1, breakpoints: breakpoints, spaceBetween: 60 },
        items.map(function (item, index) {
            return React.createElement(SwiperSlide, { key: index }, item.pageLink
                ? React.createElement("a", { href: item.pageLink, target: '_blank' },
                    React.createElement("img", { src: setLogotypeImageUrl(item.imgUrl), alt: item.imgAlt, loading: 'lazy' }))
                : React.createElement("img", { src: setLogotypeImageUrl(item.imgUrl), alt: item.imgAlt, loading: 'lazy' }));
        }),
        React.createElement("div", { className: 'empori-slideshow-navigation element-flex' },
            React.createElement(NavigationButton, { direction: Direction.left }),
            React.createElement(NavigationButton, { direction: Direction.right }))));
}
export function NavigationButton(_a) {
    var direction = _a.direction, absolute = _a.absolute;
    var swiper = useSwiper();
    var arrow = direction === Direction.right
        ? React.createElement("img", { src: '/images/Arrow-right.svg', alt: 'Navigate to the right', loading: 'lazy' })
        : React.createElement("img", { src: '/images/Arrow-left.svg', alt: 'Navigate to the left', loading: 'lazy' });
    var handleChange = function () {
        if (direction === Direction.right) {
            swiper.slideNext();
            return;
        }
        swiper.slidePrev();
    };
    return (React.createElement("div", { className: className("empori-slideshow-navigation-item ".concat(Direction[direction]), {
            'nav-absolute': absolute
        }), onClick: handleChange }, arrow));
}
